import { cn } from '~/lib/shadcnUtils';
import { OTPInput as OTPInputPrimitive, type SlotProps, REGEXP_ONLY_DIGITS } from 'input-otp';

interface OTPInputComponentProps {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  disabled?: boolean;
  onComplete?: (value: string) => void;
}

function Slot(props: SlotProps) {
  return (
    <div
      className={cn(
        'relative flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-lg border border-[#3B3B3E] bg-transparent font-medium text-white shadow-sm transition-all',
        {
          'z-10 border-2 border-white ring-2 ring-white/20': props.isActive,
        },
      )}
    >
      {props.char !== null && <div className="text-lg sm:text-xl">{props.char}</div>}
      {props.hasFakeCaret && props.char === null && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="h-6 w-0.5 animate-pulse bg-white" />
        </div>
      )}
    </div>
  );
}

export function OtpInput({ value, onChange, maxLength = 6, disabled = false, onComplete }: OTPInputComponentProps) {
  return (
    <OTPInputPrimitive
      value={value}
      onChange={(newValue) => {
        onChange(newValue);

        if (newValue.length === maxLength && onComplete) {
          onComplete(newValue);
        }
      }}
      maxLength={maxLength}
      disabled={disabled}
      pattern={REGEXP_ONLY_DIGITS}
      containerClassName="flex items-center justify-center gap-2 sm:gap-3 has-[:disabled]:opacity-50"
      render={({ slots }) => (
        <div className="flex gap-2 sm:gap-3">
          {slots.map((slot, idx) => (
            <Slot key={idx} {...slot} />
          ))}
        </div>
      )}
    />
  );
}
